// extracted by mini-css-extract-plugin
module.exports = {"appButton":"styles_appButton__TO3H_","primary":"styles_primary__2LU_E","secondary":"styles_secondary__EJjd3","tertiary":"styles_tertiary__deCsH"};